export enum FlexComponent {
  AgentDesktopView = "AgentDesktopView",
  CallCanvas = "CallCanvas",
  CallCanvasActions = "CallCanvasActions",
  CRMContainer = "CRMContainer",
  MainHeader = "MainHeader",
  MessageListItem = "MessageListItem",
  NoTasksCanvas = "NoTasksCanvas",
  ParticipantCanvas = "ParticipantCanvas",
  QueueStats = "QueueStats",
  SideNav = "SideNav",
  TaskCanvasHeader = "TaskCanvasHeader",
  TaskCanvasTabs = "TaskCanvasTabs",
  TaskListButtons = "TaskListButtons",
  TaskOverviewCanvas = "TaskOverviewCanvas",
  TeamsView = "TeamsView",
  ViewCollection = "ViewCollection",
  WorkerCanvas = "WorkerCanvas",
  WorkersDataTable = "WorkersDataTable",
  WorkerDirectory = "WorkerDirectory",
  WorkerProfile = "WorkerProfile",
  OutboundDialerPanel = "OutboundDialerPanel",
  TaskInfoPanel = "TaskInfoPanel",
  SupervisorTaskCanvasHeader = "SupervisorTaskCanvasHeader"
}
